import { gql } from '@apollo/client';

export const getAssetIds = gql`
	query getAssetIds($assetType: AssetType!, $transporterId: Int!) {
		assetIds(assetType: $assetType, transporterId: $transporterId)
	}
`;
